import { AuthService } from '../auth/auth.service';
import { SatelliteData, SatMapService } from './sat-map.service';

import { DatexPipe } from '../shared/datex.pipe';

import { BreakpointObserver } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  DestroyRef,
  inject,
  model,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import {
  ChangeContext,
  NgxSliderModule,
  Options,
} from '@angular-slider/ngx-slider';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { setPigeonsRoute } from '../constants/constants';
import { LngLatLike } from 'mapbox-gl';
import moment, { Moment } from 'moment/moment';
import { map, noop, Subscription, tap, timer } from 'rxjs';
import { sliderBaseOptions } from 'src/constants';

export const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  MatButtonModule,
  MatFormFieldModule,
  MatSelectModule,
  MatCardModule,
  MatDividerModule,
  NgxSliderModule,
  TranslateModule,
];
export const COMPONENTS = [FaIconComponent];

@Component({
  selector: 'app-sat',
  templateUrl: './sat.component.html',
  styleUrls: ['./sat.component.scss'],
  providers: [SatMapService],
  imports: [...MODULES, ...COMPONENTS, DatexPipe],
})
export class SatComponent implements OnInit, OnDestroy {
  private platform = inject(Platform);
  private breakpointObserver = inject(BreakpointObserver);
  private auth = inject(AuthService);
  public satMapService = inject(SatMapService);

  satTypes = signal([]);
  selectedSatType = signal<string>(undefined);
  mapCenter: LngLatLike;
  satData = signal<SatelliteData>(undefined);
  animationIsRunning = signal(false);
  sliderDate = model<number>();
  sliderDates: number[];
  sliderOptions = signal<Options>(sliderBaseOptions);
  animationSubscription: Subscription;
  animationSpeed = signal(500);
  timeRange = signal(3);
  showMobileFormFields = signal(false);

  private handset = toSignal(
    this.breakpointObserver
      .observe(['(max-width: 950px)'])
      .pipe(map(r => r.matches)),
    { initialValue: this.breakpointObserver.isMatched(['(max-width: 950px)']) }
  );

  readonly isMobilePlatform = computed(
    () => this.handset() || this.platform.ANDROID || this.platform.IOS
  );

  private destroyRef = inject(DestroyRef);

  constructor() {
    this.listenToMapLoad();
  }

  get mapDtg(): Moment {
    return moment.unix(this.sliderDate());
  }

  ngOnInit(): void {
    this.getProductDetails();
    this.satMapService.language = this.auth.getLanguage();
    this.initSatData(true);
  }

  ngOnDestroy(): void {
    if (this.animationSubscription) {
      this.animationSubscription.unsubscribe();
    }
  }

  initSatData(firstTime: boolean): void {
    this.satMapService
      .getSatData(this.selectedSatType(), this.timeRange(), true)
      .then(satData => {
        this.satData.set([...satData]);
        this.setSliderOptions();
        if (firstTime) {
          this.satMapService.buildMap(
            this.mapCenter,
            this.selectedSatType(),
            this.timeRange()
          );
        } else {
          this.satMapService.removeSatLayers();
          this.satMapService.addSatLayers();
        }
      });
  }

  getProductDetails(): void {
    const customerDocument = this.auth.getCustomerDocument();
    const satTypes = [];
    let center: LngLatLike;
    if (
      customerDocument.hasOwnProperty('satelliteProducts') &&
      customerDocument.satelliteProducts.length > 0
    ) {
      for (const satProduct of customerDocument.satelliteProducts) {
        if (this.auth.isProductActive('satelliteProducts', satProduct.id)) {
          if (
            center === undefined &&
            satProduct.hasOwnProperty('points') &&
            satProduct.points !== null &&
            satProduct.points.length > 0
          ) {
            center = [
              satProduct.points[0].longitude,
              satProduct.points[0].latitude,
            ];
          }
          if (
            satProduct.hasOwnProperty('types') &&
            satProduct.types !== null &&
            satProduct.types.length > 0
          ) {
            for (const satType of satProduct.types) {
              if (satTypes.indexOf(satType) < 0) {
                satTypes.push(satType);
              }
            }
          }
        }
      }
    }
    this.satTypes.set([...satTypes]);
    if (satTypes.length > 0) {
      this.selectedSatType.set(satTypes[0]);
    }
    this.mapCenter = center;
  }

  /*setSliderOptions(): void {
    const tickStep = this.timeRange() / 3;
    this.sliderDates = [];

    const maxLabels = 10;
    const total = this.satData.length;
    const labelInterval = Math.max(1, Math.ceil(total / maxLabels));

    this.sliderOptions.set({
      showTicks: true,
      showTicksValues: false,
      stepsArray: this.satData().map((feature: any, idx: number) => {
        const showLabel = idx % labelInterval === 0;
        const dtg = feature.dtg;
        const legend = this.isMobilePlatform
          ? moment(dtg).minutes() === 0 || moment(dtg).minutes() === 30
            ? moment(dtg).format('HH:mm')
            : ''
          : moment(dtg).format('HH:mm');
        const dtgUnix = moment(dtg).unix();
        this.sliderDates.push(dtgUnix);
        return {
          value: dtgUnix,
          legend: showLabel ? legend : '',
          // legend: (dtg === this.geoJson.features[0].properties.dtg ||
          //  dtg === this.geoJson.features[this.geoJson.features.length - 1].properties.dtg) ?
          //  moment(dtg).format('HH:mm') : ''
        };
      }),
      translate: (value: number, label: LabelType): string => {
        return moment.unix(value).format('HH:mm');
      },
      ticksValuesTooltip: (step: number) => {
        const dtg = moment(step);
        return dtg.format('HH:mm');
      },
      tickStep,
      getTickColor: (value: number): string => {
        return '#399DE6';
      },
    });
    this.setSliderDate(this.satData().length - 1);
  }*/

  setSliderOptions(): void {
    const data = this.satData();
    const range = this.timeRange();
    if (!data || data.length === 0) return;

    let hourStep: number;
    switch (range) {
      case 3:
        hourStep = 0.5;
        break; // Alle 30 Min ein Label
      case 6:
        hourStep = 0.5;
        break; // Alle 30 Min ein Label
      case 12:
        hourStep = 1;
        break; // Jede Stunde ein Label
      case 24:
        hourStep = 2;
        break; // Alle 2 Stunden
      default:
        hourStep = 1;
    }

    const blueTickTimestamps = new Set<number>();
    this.sliderDates = [];

    const steps = data.map((feature: any, idx: number) => {
      const dtg = moment(feature.dtg);
      const unix = dtg.unix();
      const mins = dtg.minutes();
      const hour = dtg.hour();

      this.sliderDates.push(unix);

      // NEU: Prüfung auf volle ODER halbe Stunde
      const isHalfHourStep = mins === 0 || mins === 30;

      // Hilfsvariable für die Logik (Stunde + 0.5 wenn es 30 Min sind)
      const currentTimeValue = hour + (mins === 30 ? 0.5 : 0);

      // BLAUE TICKS Logik
      let isMajor = false;
      if (range === 3) {
        isMajor = true; // Im 3h-Bereich alle 15min blau
      } else {
        // Nur blau wenn es 00 oder 30 ist UND der hourStep passt
        isMajor = isHalfHourStep && currentTimeValue % hourStep === 0;
      }

      // LABEL Logik
      let showLabel = isHalfHourStep && currentTimeValue % hourStep === 0;

      // IMMER Start und Ende zeigen
      if (idx === 0 || idx === data.length - 1) {
        isMajor = true;
        showLabel = true;
      }

      if (isMajor) blueTickTimestamps.add(unix);

      return {
        value: unix,
        legend: showLabel ? dtg.format('HH:mm') : '',
      };
    });

    this.sliderOptions.set({
      showTicks: true,
      showTicksValues: false,
      hidePointerLabels: true,
      hideLimitLabels: true,
      stepsArray: steps,
      translate: (value: number) => moment.unix(value).format('HH:mm'),
      getTickColor: (value: number): string => {
        const timestamp = this.sliderDates[value] ?? value;

        return blueTickTimestamps.has(timestamp) ? '#399DE6' : '#f0f0f0';
      },
    });

    this.setSliderDate(this.sliderDates.length - 1);
  }

  setSliderDate(pos: number): void {
    this.sliderDate.set(this.sliderDates[pos]);
    this.satMapService.setTimeStep(pos);
  }

  startTimer(): void {
    const marwisTimer = timer(0, this.animationSpeed());
    this.animationSubscription = marwisTimer.subscribe(() => {
      const oldSliderPos = this.sliderDates.indexOf(this.sliderDate());
      const newSliderPos =
        oldSliderPos >= this.sliderDates.length - 1 ? 0 : oldSliderPos + 1;
      this.sliderDate.set(this.sliderDates[newSliderPos]);
      this.satMapService.setTimeStep(newSliderPos);
    });
  }

  stopTimer(): void {
    if (this.animationSubscription) {
      this.animationSubscription.unsubscribe();
    }
  }

  onChangeSatType(selection: MatSelectChange): void {
    this.selectedSatType.set(selection.value);
    this.initSatData(false);
  }

  onChangeTimeRange(selection: MatSelectChange): void {
    this.timeRange.set(selection.value);
    this.initSatData(false);
  }

  onChangeSpeed(selection: MatSelectChange): void {
    this.animationSpeed.set(selection.value);
    if (this.animationIsRunning()) {
      this.stopTimer();
      this.startTimer();
    }
  }

  onPlay(): void {
    this.animationIsRunning.set(true);
    this.startTimer();
  }

  onPause(): void {
    this.animationIsRunning.set(false);
    this.stopTimer();
  }

  onSliderChange(event: ChangeContext): void {
    if (this.animationIsRunning()) {
      this.animationIsRunning.set(false);
      this.stopTimer();
    }
    const pos = this.sliderDates.indexOf(event.value);
    this.setSliderDate(pos);
  }

  private listenToMapLoad() {
    this.satMapService.mapLoaded
      .pipe(
        tap(loaded => {
          if (loaded) {
            setPigeonsRoute(
              this.satMapService.map,
              this.auth.isProductActive('pigeonProducts')
            );
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(noop);
  }
}
